import { Link } from 'react-router-dom';
import { CompanyConfig } from '../../company.config';

export const FooterComponent = () => {
  return (
    <>
      <div className="slant-top"></div>
      <footer>
        <div className="container-xl">
          <div className="row">
            <div className="col-12 text-end">
              <p>
                &copy; Copyright 2025. All Rights Reserved.
                <span className="d-block d-sm-inline-block">
                  <Link
                    className="mx-1"
                    title="Privacy Policy"
                    to={CompanyConfig.privacyUrl}
                    data-discover="true"
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>
                  &amp;
                  <Link
                    className="mx-1"
                    title="Terms of Use"
                    to={CompanyConfig.termsUrl}
                    data-discover="true"
                    target="_blank"
                  >
                    Terms of Use
                  </Link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterComponent;
